import { buildBillsTableColumnConfiguration } from '../utils/buildBillsTableColumnConfiguration'

export const defaultBillsTableColumnConfiguration = buildBillsTableColumnConfiguration({
  excludedColumnKeys: ['syncStatus', 'eInvoiceStatus'],
})
export const ebpBillsTableColumnConfiguration = buildBillsTableColumnConfiguration({
  excludedColumnKeys: ['billStatus', 'syncStatus', 'syncStatusIcon'],
})
export const autoForwardingBillsTableColumnConfiguration = buildBillsTableColumnConfiguration({
  excludedColumnKeys: ['billStatus', 'eInvoiceStatus', 'syncStatusIcon'],
})
